module.exports = __webpack_public_path__ + "static/media/0018.10bf529c.jpg";